import { Quill } from 'react-quill';
import CustomQuillTooltip from './CustomQuillTooltip';
class CustomTooltipModule {
  constructor(quill, options) {
    this.quill = quill;
    this.options = options;

    this.tooltip = new CustomQuillTooltip(quill);
    this.tooltip.customStyle();
    this.showTooltip = false;
    quill.on('editor-change', this.onEditorChange);
  }

  onShowTooltip = () => {
    this.showTooltip = true;
    this.tooltip.show();
    this.tooltip.position(this.quill.getBounds(this.quill.getSelection()));
  };

  showTooltipIfLink = (position, length, source) => {
    this.quill.setSelection(position, length, source);
    const formats = this.quill.getFormat();
    if (formats['link']) {
      this.showTooltip = true;
      this.tooltip.show();
      this.tooltip.position(this.quill.getBounds(this.quill.getSelection()));
      setTimeout(() => this.quill.theme.tooltip.hide(), 0);
    }
  }

  onEditorChange = (event, range, range2, source) => {
    if (this.showTooltip) {
      this.tooltip.hide();
      this.showTooltip = false;
    }
    if (event === 'selection-change' && range) {
      const [linkBlot] = this.quill.scroll.descendant(Quill.imports['formats/link'], range.index);
      const [embedBlot] = this.quill.scroll.descendant(
        Quill.imports['formats/mention'],
        range.index,
      );
      const currentBlot = embedBlot ? embedBlot.parent : linkBlot;
      if (currentBlot && source !== 'custom') {
        const hrefValue = currentBlot.domNode.href;
        // handle single mention block and change it to link format.
        if (embedBlot && !hrefValue) {
          const position = embedBlot?.offset(this.quill.scroll);
          this.showTooltipIfLink(position, 1, 'custom');
          return;
        }
        const selectedBlots = new Set();
        let prev = currentBlot.prev;
        let next = currentBlot.next;
        let hasMention = false;
        const hasMentionEmbed = blot => {
          if (hrefValue && blot.domNode.href && blot.domNode.href === hrefValue) {
            selectedBlots.add(blot);
            blot.children.forEach(item => {
              if (item.domNode.className === 'mention') {
                hasMention = true;
              }
            });
          }
        };
        while (next) {
          hasMentionEmbed(next);
          next = next.next;
        }
        hasMentionEmbed(currentBlot);
        while (prev) {
          hasMentionEmbed(prev);
          prev = prev.prev;
        }
        if (hasMention) {
          const position = [...selectedBlots].reverse()[0]?.offset(this.quill.scroll);
          let length = 0;
          selectedBlots.forEach(item => {
            length += Quill.find(item.domNode).length();
          });
          this.showTooltipIfLink(position, length, 'custom');
        }
      }
    }
  };
}

export default CustomTooltipModule;